import React, { useEffect, useRef, useState } from "react";
import {
    getLoggedUserDetails,
    getLoginLogoutUserStatus,
    getUserProfilePic,
    loadUserDetails,
    getCurrentUser,
    loadUserProfileLogo,
    loadUserProfilePic,
    loginStatusUpdate,
    loginLogoutUpdateStatus,
    getLoggedPartnerUserDetails,
    loadPartnerUserDetails
} from "../store/auth";
import { useDispatch, useSelector } from "react-redux";
import ChangePassword from "../../Components/ChangePassword";
import Help from "../../Components/Support/Help";
import SupportPupup from "../../Components/Support/SupportPopup";
import AddSecurityQuestion from "../../Components/ApplicantProcessing/AddSecurityQuestion";
import Profile from "../../Components/Comman/Profile";
import WelcomePage from "../../Components/WelcomePage";
import { getPageTitle, getWorkbenchHelpDocs, loadWorkbenchHelpDocs } from "../store/layoutUI";
import config from "../../config.json";
import { getFieldData } from "../../Services/appService";

const HEADER_STYLES = {
    shell: {
        background: "#ffffff",
        // borderRadius: "0 0 18px 18px",
        boxShadow: "0 14px 40px rgba(15, 23, 42, 0.08)",
        color: "#0f172a",
        // marginBottom: "16px",
        overflow: "visible",
        position: "relative",
        width: "100%",
        borderBottom: "1px solid rgba(203, 213, 225, 0.85)"
    },
    topRow: {
        // padding: "18px 24px 14px 24px",
        borderBottom: "1px solid rgba(203, 213, 225, 0.75)",
        position: "relative",
        zIndex: 5
    },
    subtitle: {
        fontSize: "12px",
        letterSpacing: "0.16em",
        textTransform: "uppercase",
        color: "rgba(221, 230, 241, 0.84)",
        marginBottom: "8px"
    },
    title: {
        fontSize: "34px",
        fontWeight: 700,
        lineHeight: 1.1,
        marginBottom: "10px",
        color: "#f8fbff"
    },
    titleSupport: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        fontSize: "13px",
        fontWeight: 500,
        color: "#334155",
        maxWidth: "920px",
        padding: "8px 18px",
        letterSpacing: "0.01em",
        width: "auto",
        textAlign: "center",
        borderRadius: "999px",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        background: "#f8fafc",
        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.9)"
    },
    titleSupportWrap: {
        display: "flex",
        justifyContent: "center",
        padding: "6px 24px 6px 24px"
    },
    titleSupportAccent: {
        width: "22px",
        height: "1px",
        background: "rgba(148, 163, 184, 0.9)",
        flexShrink: 0
    },
    brandRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "20px",
        marginBottom: "4px",
        flexWrap: "wrap"
    },
    brandCopy: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "6px",
        paddingTop: "2px"
    },
    brandLogo: {
        height: "84px",
        width: "auto",
        display: "block",
        backgroundColor: "#ffffff",
        padding: "8px 12px",
        borderRadius: "6px",
        //boxShadow: "0 10px 24px rgba(14, 24, 44, 0.18)"
    },
    profileCard: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "14px",
        width: "100%",
        minHeight: "84px",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
        borderRadius: "18px",
        padding: "12px 14px",
        color: "#0f172a",
        backdropFilter: "blur(6px)",
        overflow: "visible",
        zIndex: 6
    },
    profileMain: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        minWidth: 0,
        flex: 1
    },
    avatar: {
        width: "50px",
        height: "50px",
        objectFit: "cover",
        borderRadius: "50%",
        border: "2px solid rgba(228, 236, 244, 0.45)",
        //boxShadow: "0 8px 24px rgba(22, 35, 63, 0.22)"
    },
    userContent: {
        minWidth: 0,
        flex: 1
    },
    userName: {
        fontSize: "17px",
        fontWeight: 700,
        lineHeight: 1.2,
        marginBottom: "6px",
        color: "#0f172a"
    },
    detailRow: {
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
        marginBottom: "5px"
    },
    detailPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "4px 8px",
        borderRadius: "999px",
        backgroundColor: "#eef2f7",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        fontSize: "11px",
        color: "#334155",
        fontWeight: 600,
        lineHeight: 1
    },
    userMeta: {
        fontSize: "12px",
        color: "#64748b",
        marginBottom: "0"
    },
    dropdownButton: {
        border: "none",
        background: "#e2e8f0",
        color: "#334155",
        width: "30px",
        height: "30px",
        borderRadius: "999px",
        cursor: "pointer"
    },
    quickRow: {
        // padding: "5px 24px 5px 24px",
        background: "#ffffff",
        position: "relative",
        borderBottom: "1px solid rgba(203, 213, 225, 0.75)",
        borderTop: "1px solid rgba(203, 213, 225, 0.75)",
        zIndex: 1
    },
    quickRowInner: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "16px",
        flexWrap: "wrap"
    },
    quickInfoBlock: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
        minHeight: "40px"
    },
    portalBadge: {
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "999px",
        border: "1px solid rgba(191, 219, 254, 0.95)",
        backgroundColor: "#eff6ff",
        padding: "8px 14px",
        fontSize: "12px",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        color: "#1d4ed8",
    },
    quickHint: {
        fontSize: "12px",
        color: "#64748b",
        letterSpacing: "0.02em"
    },
    quickButton: {
        borderRadius: "999px",
        border: "1px solid rgba(203, 213, 225, 0.95)",
        backgroundColor: "#f8fafc",
        color: "#1e293b",
        padding: "8px 13px",
        fontSize: "13px",
        fontWeight: 600,
        marginTop: "0",
        transition: "background-color 0.2s ease, border-color 0.2s ease"
    },
    logoutButton: {
        borderRadius: "999px",
        border: "1px solid rgba(252, 165, 165, 0.9)",
        backgroundColor: "#fef2f2",
        color: "#b91c1c",
        padding: "8px 13px",
        fontSize: "13px",
        fontWeight: 700,
        marginTop: "0"
    },
    actionWrap: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px"
    },
    dropdownMenu: {
        position: "absolute",
        top: "calc(100% + 10px)",
        right: 0,
        minWidth: "240px",
        backgroundColor: "#f8fbff",
        borderRadius: "14px",
        boxShadow: "0 16px 40px rgba(22, 35, 63, 0.2)",
        padding: "8px",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        zIndex: 1000
    },
    dropdownItem: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        width: "100%",
        border: "none",
        background: "transparent",
        color: "#1e293b",
        textAlign: "left",
        padding: "10px 12px",
        borderRadius: "10px",
        fontSize: "14px",
        fontWeight: 600
    },
    toggleButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "36px",
        height: "36px",
        borderRadius: "8px",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        background: "#f8fafc",
        color: "#334155",
        fontSize: "14px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        marginLeft: "10px"
    }
};

const TopMenu = () => {
    const [showHide, setShowHide] = useState(false);
    const [helpShowHide, setHelpShowHide] = useState(false);
    const [issueShowHide, setIssueShowHide] = useState(false);
    const [securityShowHide, setSecurityShowHide] = useState(false);
    const [profileShowHide, setProfileShowHide] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [profilePicData, setProfilePicData] = useState(null);
    const [firstLogin, setFirstLogin] = useState(false);
    const [welShowHide, setWelShowHide] = useState(false);
    const [helpDocs, setHelpDocs] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [logoutProcess, setLogoutProcess] = useState(false);
    const [headerVisible, setHeaderVisible] = useState(true);

    const dropdownRef = useRef(null);

    const userDetailsSelector = useSelector(getLoggedUserDetails);
    const userProfilePicSelector = useSelector(getUserProfilePic);
    const workbenchHelpDocsSelector = useSelector(getWorkbenchHelpDocs);
    const pageTitleSelector = useSelector(getPageTitle);
    const loginLogoutUserStatusSelector = useSelector(getLoginLogoutUserStatus);
    const partnerUserDetailsSelector = useSelector(getLoggedPartnerUserDetails);

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const usrType = localStorage.getItem("userType");

    useEffect(() => {
        if (!currentUser?.id) return;

        if (currentUser.linkUser) {
            if (!partnerUserDetailsSelector) {
                dispatch(loadPartnerUserDetails(currentUser.id));
            }
        } else if (!userDetailsSelector) {
            dispatch(loadUserDetails(currentUser.id));
        }
    }, []);

    useEffect(() => {
        if (usrType === "recruiter") {
            dispatch(loadWorkbenchHelpDocs(config.HelpDocIds.RecruiterDoc));
        } else if (usrType === "subcontractor") {
            dispatch(loadWorkbenchHelpDocs(config.HelpDocIds.SubcontractorDoc));
        } else {
            dispatch(loadWorkbenchHelpDocs(config.HelpDocIds.CandidateDoc));
        }
    }, []);

    useEffect(() => {
        if (workbenchHelpDocsSelector) {
            setHelpDocs(workbenchHelpDocsSelector);
        }
    }, [workbenchHelpDocsSelector]);

    useEffect(() => {
        if (userDetailsSelector && !currentUser?.linkUser) {
            setUserDetails(userDetailsSelector);

            dispatch(loadUserProfilePic(currentUser.id));

            let usrId = currentUser.id;
            if (currentUser.linkUser) {
                usrId = currentUser.linkUser;
            }
            dispatch(loadUserProfileLogo(usrId));

            if (userDetailsSelector?.maxtasks === null) {
                dispatch(loginStatusUpdate(currentUser.id));
                setFirstLogin(true);
                setSecurityShowHide(true);
            } else if (userDetailsSelector?.maxtasks === 1) {
                dispatch(loginStatusUpdate(currentUser.id));
                setWelShowHide(true);
            } else {
                setFirstLogin(false);
            }
        }
    }, [userDetailsSelector]);

    useEffect(() => {
        if (partnerUserDetailsSelector) {
            setUserDetails(partnerUserDetailsSelector);
            dispatch(loadUserProfilePic(currentUser.id));

            let usrId = currentUser.id;
            if (currentUser.linkUser) {
                usrId = currentUser.linkUser;
            }
            dispatch(loadUserProfileLogo(usrId));

            if (partnerUserDetailsSelector?.maxtasks === null) {
                dispatch(loginStatusUpdate(currentUser.id));
                setFirstLogin(true);
                setSecurityShowHide(true);
            } else if (partnerUserDetailsSelector?.maxtasks === 1) {
                dispatch(loginStatusUpdate(currentUser.id));
                setWelShowHide(true);
            } else {
                setFirstLogin(false);
            }
        }
    }, [partnerUserDetailsSelector]);

    useEffect(() => {
        if (userProfilePicSelector) {
            setProfilePicData(
                process.env.REACT_APP_API_BASEURL + "/ProfilePics/" + userProfilePicSelector
            );
        }
    }, [userProfilePicSelector]);

    useEffect(() => {
        if (loginLogoutUserStatusSelector) {
            setLogoutProcess(false);
            window.location = "/login";
        }
    }, [loginLogoutUserStatusSelector]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const handleWelShowHide = () => {
        setWelShowHide((prev) => !prev);
    };

    const handleModalShowHide = () => {
        setShowHide((prev) => !prev);
    };

    const handleHelpShowHide = () => {
        setHelpShowHide((prev) => !prev);
    };

    const handleIssueShowHide = () => {
        setIssueShowHide((prev) => !prev);
    };

    const handleSecurityShowHide = () => {
        setSecurityShowHide((prev) => !prev);
        setIsDropdownOpen(false);
    };

    const handleProfileShowHide = () => {
        setProfileShowHide((prev) => !prev);
        setIsDropdownOpen(false);
    };

    const handleLogout = () => {
        if (currentUser?.id) {
            setLogoutProcess(true);
            dispatch(loginLogoutUpdateStatus(currentUser.id));
        }
    };

    const getPortalLabel = () => {
        if (!usrType) return "Portal";
        return usrType.charAt(0).toUpperCase() + usrType.slice(1) + " Portal";
    };

    const getUserDisplayName = () => {
        const firstName = userDetails?.performername || "";
        const lastName = userDetails?.lastName || "";
        const fullName = `${firstName} ${lastName}`.trim();
        return fullName || "Portal User";
    };

    const getRoleLabel = () => {
        if (usrType !== "candidate") {
            if (currentUser?.linkUser) return currentUser?.role || "Partner User";
            return userDetailsSelector?.title || "User";
        }

        return getFieldData(
            userDetailsSelector?.performerData,
            "projectengagement",
            "PositionTitle"
        ) || "Candidate";
    };

    const getLastLoginLabel = () => {
        return new Date().toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric"
        });
    };

    const handleCurrentTask = async () => { };
    const handleWorkflowTask = () => { };

    const dropdownActionStyle = (isDanger) => ({
        ...HEADER_STYLES.dropdownItem,
        color: isDanger ? "#b91c1c" : "#1e293b"
    });

    const profileImage = profilePicData || "../../assets/img/theme/team-4.png";

    return <>
        <div className="w-100 px-0">
            <div style={HEADER_STYLES.shell} className="col-auto">
                <div className="align-items-center" style={HEADER_STYLES.topRow}>
                    {headerVisible &&
                        <div className="row pt-2 pb-2" style={{ background: "linear-gradient(270deg, #ffffff 0%, #f8fafc 100%)", }}>
                            <div className="col-lg-7 col-md-12">
                                <div style={HEADER_STYLES.brandRow}>
                                    <img
                                        src="/assets/Img/logo.png"
                                        alt="Portal logo"
                                        style={HEADER_STYLES.brandLogo}
                                    />

                                </div>

                            </div>

                            <div className="col-lg-5 col-md-12">
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                                    <div ref={dropdownRef} style={HEADER_STYLES.profileCard}>
                                        <div style={HEADER_STYLES.profileMain}>
                                            <img
                                                alt="Profile"
                                                src={profileImage}
                                                style={HEADER_STYLES.avatar}
                                            />
                                            <div style={HEADER_STYLES.userContent}>
                                                <div style={HEADER_STYLES.userName}>{getUserDisplayName()}</div>
                                                <div style={HEADER_STYLES.detailRow}>
                                                    <span style={HEADER_STYLES.detailPill}>
                                                        <i className="fa fa-id-badge" aria-hidden="true"></i>
                                                        Reg ID: {currentUser?.id || "-"}
                                                    </span>
                                                    <span style={HEADER_STYLES.detailPill}>
                                                        <i className="fa fa-briefcase" aria-hidden="true"></i>
                                                        Role: {getRoleLabel()}
                                                    </span>
                                                    <span style={HEADER_STYLES.detailPill}>
                                                        <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                        Last Login: {getLastLoginLabel()}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            aria-label="Open profile actions"
                                            aria-expanded={isDropdownOpen}
                                            onClick={() => setIsDropdownOpen((prev) => !prev)}
                                            style={HEADER_STYLES.dropdownButton}
                                        >
                                            <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                                        </button>

                                        {isDropdownOpen && (
                                            <div style={HEADER_STYLES.dropdownMenu}>
                                                <button
                                                    type="button"
                                                    style={dropdownActionStyle(false)}
                                                    onClick={handleProfileShowHide}
                                                >
                                                    <i className="fa fa-user-circle-o" aria-hidden="true"></i>
                                                    <span>My Profile</span>
                                                </button>
                                                <button
                                                    type="button"
                                                    style={dropdownActionStyle(false)}
                                                    onClick={() => {
                                                        setIsDropdownOpen(false);
                                                        handleModalShowHide();
                                                    }}
                                                >
                                                    <i className="fa fa-lock" aria-hidden="true"></i>
                                                    <span>Change Password</span>
                                                </button>
                                                <button
                                                    type="button"
                                                    style={dropdownActionStyle(false)}
                                                    onClick={handleSecurityShowHide}
                                                >
                                                    <i className="fa fa-shield" />
                                                    <span>Security Questions</span>
                                                </button>
                                                <button
                                                    type="button"
                                                    style={dropdownActionStyle(false)}
                                                    onClick={() => {
                                                        setIsDropdownOpen(false);
                                                        handleHelpShowHide();
                                                    }}
                                                >
                                                    <i className="fa fa-question-circle"></i>
                                                    <span>Help Center</span>
                                                </button>
                                                <button
                                                    type="button"
                                                    style={dropdownActionStyle(true)}
                                                    onClick={handleLogout}
                                                    disabled={logoutProcess}
                                                >
                                                    <i className={logoutProcess ? "fa fa-spinner fa-spin" : "ni ni-user-run"} />
                                                    <span>{logoutProcess ? "Signing out..." : "Logout"}</span>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>}

                    <div style={HEADER_STYLES.quickRow} className="row pt-2 pb-2">
                        <div style={HEADER_STYLES.quickInfoBlock} className="col-4">
                            <span style={HEADER_STYLES.portalBadge}>{getPortalLabel()}</span>
                        </div>
                        <div style={HEADER_STYLES.actionWrap} className="col-8">
                            <button
                                type="button"
                                onClick={() => setWelShowHide(true)}
                                style={HEADER_STYLES.quickButton}
                            >
                                <i className="fa fa-envelope-open mr-2" aria-hidden="true"></i>
                                Welcome Letter
                            </button>
                            <button
                                type="button"
                                onClick={handleIssueShowHide}
                                title="Any defects/issues found in the portal can be registered in the customer support portal."
                                style={HEADER_STYLES.quickButton}
                            >
                                <i className="fa fa-life-ring mr-2" aria-hidden="true"></i>
                                Customer Support
                            </button>
                            <button
                                type="button"
                                onClick={handleHelpShowHide}
                                style={HEADER_STYLES.quickButton}
                            >
                                <i className="fa fa-question-circle mr-2" aria-hidden="true"></i>
                                Help
                            </button>
                            <button
                                type="button"
                                onClick={handleLogout}
                                disabled={logoutProcess}
                                style={HEADER_STYLES.logoutButton}
                            >
                                <i className={logoutProcess ? "fa fa-spinner fa-spin mr-2" : "ni ni-user-run mr-2"} />
                                {logoutProcess ? "Signing out..." : "Logout"}
                            </button>
                        </div>
                    </div>

                    <div style={HEADER_STYLES.titleSupportWrap} className="row pt-2 pb-2">
                        <div style={HEADER_STYLES.titleSupport} className="col-12">
                            <span style={HEADER_STYLES.titleSupportAccent}></span>
                            <span>
                                Next generation human resource onboarding, contract, time log and invoicing system.
                            </span>
                            <span style={HEADER_STYLES.titleSupportAccent}></span>
                        </div>
                        <div className="col-auto d-flex justify-content-end">
                            <button
                                type="button"
                                onClick={() => setHeaderVisible(!headerVisible)}
                                title={headerVisible ? "Hide Header" : "Show Header"}
                                style={HEADER_STYLES.toggleButton}
                            >
                                <i className={`fa fa-chevron-${headerVisible ? "up" : "down"}`} aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {showHide &&
                <ChangePassword
                    handleModalShowHide={handleModalShowHide}
                    showHide={showHide}
                ></ChangePassword>}
            {profileShowHide &&
                <Profile
                    handleProfileShowHide={handleProfileShowHide}
                    profileShowHide={profileShowHide}
                    usrType={usrType}
                ></Profile>}
            {helpShowHide &&
                <Help
                    helpShowHide={helpShowHide}
                    handleHelpShowHide={handleHelpShowHide}
                    module={pageTitleSelector}
                    helpDocs={helpDocs}
                ></Help>}
            {issueShowHide &&
                <SupportPupup
                    handleIssueShowHide={handleIssueShowHide}
                    issueShowHide={issueShowHide}
                    handleCurrentTask={handleCurrentTask}
                    handleWorkflowTask={handleWorkflowTask}
                ></SupportPupup>}

            {securityShowHide && <AddSecurityQuestion
                firstLogin={firstLogin}
                securityShowHide={securityShowHide}
                handleSecurityShowHide={handleSecurityShowHide}
                userDetails={userDetails}
            ></AddSecurityQuestion>}
            {welShowHide && <WelcomePage
                userDetails={userDetails}
                welShowHide={welShowHide}
                handleWelShowHide={handleWelShowHide}
            ></WelcomePage>}
        </div>
    </>
}

export default TopMenu;
